module.exports = __webpack_public_path__ + "img/vol06_character_img04_sp.9d4dacc4.png";